import { render, staticRenderFns } from "./Registro_editar.vue?vue&type=template&id=687563df"
import script from "./Registro_editar.vue?vue&type=script&lang=js"
export * from "./Registro_editar.vue?vue&type=script&lang=js"
import style0 from "./Registro_editar.vue?vue&type=style&index=0&id=687563df&prod&lang=css"
import style1 from "./Registro_editar.vue?vue&type=style&index=1&id=687563df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports